import ServiceBase from './ServiceBase';

export default class BlogPostsService extends ServiceBase {
    getBlogPosts(pageIndex = 0, blogPostChannel = null) {
        const searchParams = {
            pageIndex,
        };

        if (blogPostChannel !== null) {
            searchParams.blogPostChannel = blogPostChannel;
        }

        return this.request('get', 'blog/getblogposts', {
            params: searchParams,
        });
    }
}